export default "__VITE_PUBLIC_ASSET__ab1f247c__"